import { Outlet, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import "../styles/globals.css";
import { FullscreenManager } from "./FullscreenManager";

const NAV = [
  { to: "/", label: "today" },
  { to: "/calendar", label: "calendar" },
  { to: "/stats", label: "stats" },
  { to: "/chat", label: "ai" },
  { to: "/audit", label: "audit" },
  { to: "/settings", label: "settings" },
];

export function Layout() {
  const path = useLocation();
  const [online, setOnline] = useState<boolean>(
    typeof navigator !== "undefined" ? navigator.onLine : true,
  );

  useEffect(() => {
    const onUp = () => setOnline(true);
    const onDown = () => setOnline(false);
    window.addEventListener("online", onUp);
    window.addEventListener("offline", onDown);
    return () => {
      window.removeEventListener("online", onUp);
      window.removeEventListener("offline", onDown);
    };
  }, []);

  return (
    <div className="shukan-shell">
      {!online ? (
        <div className="shukan-banner" role="alert">
          offline — showing cached data · last sync unknown
        </div>
      ) : null}

      <header className="shukan-header">
        <div className="shukan-header-title">
          <span style={{ color: "var(--accent)" }}>$</span> shukan ·{" "}
          <span style={{ color: "var(--fg-dim)" }}>{path.pathname}</span>
        </div>
        <nav className="shukan-header-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) =>
                isActive ? "shukan-btn shukan-btn-primary" : "shukan-btn"
              }
              style={{ fontSize: "0.7rem", padding: "0.25rem 0.5rem" }}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="shukan-stdout">
        <Outlet />
      </main>
      <FullscreenManager />
    </div>
  );
}
